module.exports = __webpack_public_path__ + "static/media/22.fa9377d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/22.png
// module id = 982
// module chunks = 0